import { palette } from '@/legacy/themes/darkTheme';

export enum FeatureType {
  CONNECTOR = 'connector',
  SEGMENT = 'segment',
  MULTI_POLYGON = 'multi-polygon',
}

export const geometryToLayerType: Record<string, string> = {
  Polygon: 'fill',
  MultiPolygon: 'fill',
  LineString: 'line',
  Point: 'circle',
};

export const NEUTRAL_COLOR = '#E0FFFF';
export const COLOR_NAME_TO_HEX: Record<string, string> = {
  red: '#FF0000',
  yellow: '#FFFF00',
  green: '#008000',
  blue: '#1E90FF',
  orange: '#FFA500',
  purple: '#800080',
  pink: '#F10CF5',
  cream: '#D5D6DE',
  neutral: NEUTRAL_COLOR,
};

export const COLOR_NAME_TO_THRESHOLD: Record<string, number[]> = {
  neutral: [-Infinity, -0.000001],
  red: [-0.000001, 0.3],
  yellow: [0.3, 0.7],
  green: [0.7, 1],
  blue: [1, Infinity],
};

export enum ColorMetric {
  PRECISION = 'precision',
  RECALL = 'recall',
  AVERAGE_RECALL_BY_LABEL = 'average-recall-by-label',
  NONE = 'none',
}

export const DRAW_CONTROL_CONFIG = {
  displayControlsDefault: false,
  controls: {
    polygon: true,
  },
  styles: [
    {
      id: 'default-line', // Unique ID for the style
      type: 'line',
      paint: {
        'line-color': palette.azure[700],
        'line-width': 2,
      },
    },
    {
      id: 'default-point',
      type: 'circle',
      paint: {
        'circle-radius': 3,
        'circle-color': palette.neutral[0],
        'circle-stroke-color': palette.azure[700],
        'circle-stroke-width': 1,
      },
    },
    {
      id: 'default-polygon',
      type: 'fill',
      paint: {
        'fill-color': palette.azure[700],
        'fill-opacity': 0.2,
      },
    },
  ],
};

export const DEFAULT_COLOR_METRIC = ColorMetric.NONE;

///COLOR_MTERICS = ['precision', 'recall', 'average-recall-by-label'];

export const POLYGON_DEDUPLICATION_TOOL_LOCAL_STORAGE_KEY =
  'selected-polygon-for-deduplication-tool';
